import LeistungsseiteTemplate from "@/components/feature/LeistungsseiteTemplate";
import { allTestimonials } from "@/data/testimonials";
import mehrfamilienhausG2ContractingAsset from "@/assets/mehrfamilienhaus-g2-contracting.png";
import mehrfamilienhausHeroBgAsset from "@/assets/mehrfamilienhaus-hero-bg.png";
import asset_mehrfamilienhaus_mieterstrom from "@/assets/mehrfamilienhaus-mieterstrom.png";
import asset_mehrfamilienhaus_wert_erhalten from "@/assets/mehrfamilienhaus-wert-erhalten.png";
import asset_mehrfamilienhaus_laden_fuer_alle from "@/assets/mehrfamilienhaus-laden-fuer-alle.png";
import asset_mehrfamilienhaus_ansprechpartner from "@/assets/mehrfamilienhaus-ansprechpartner.png";
import Seo, { serviceSchema } from "@/components/feature/Seo";
export default function Mehrfamilienhaus() {
  return (
    <>
      <Seo
        title="Für Mehrfamilienhäuser | Zweering Elektrotechnik Emmerich am Rhein"
        description="Mieterstrom, Ladeinfrastruktur und Werterhalt für Mehrfamilienhäuser — Energielösungen aus einer Hand in Emmerich am Rhein und Umgebung."
        canonical="https://zweering.de/mehrfamilienhaus"
        breadcrumbs={[{"name": "Startseite", "url": "https://zweering.de/"}, {"name": "Für wen", "url": "https://zweering.de/mehrfamilienhaus"}, {"name": "Mehrfamilienhaus", "url": "https://zweering.de/mehrfamilienhaus"}]}
      />
      <LeistungsseiteTemplate
      label="FÜR WEN"
      title="FÜR MEHRFAMILIENHÄUSER"
      subline="Mieterstrom, Energieeffizienz und Werterhalt — Energielösungen für Vermieter und Eigentümergemeinschaften in Emmerich am Rhein und Umgebung."
      heroImage={mehrfamilienhausHeroBgAsset}
      heroImageAlt="Modernes Mehrfamilienhaus mit Ziegelfassade und Photovoltaik-Anlage auf dem Dach"
      leadText={
        <>
          Ein <span style={{ color: "#4CAF50" }}>MEHRFAMILIENHAUS</span> bietet große Dachflächen — und große Chancen. Mit dem
          richtigen Konzept wird Ihr Gebäude{" "}
          <span style={{ color: "#4CAF50" }}>energetisch und wirtschaftlich zukunftsfähig</span>,
          für Sie und Ihre Mieter.
        </>
      }
      panels={[
        {
          title: "MIETERSTROM ANBIETEN",
          body: (
            <>
              <p className="italic text-sm md:text-base text-foreground-500 mb-4">
                Strom vom eigenen Dach — direkt an die Mieter weitergegeben. Faire Preise, klares Konzept, gesetzlich geregelt.
              </p>
              <p>Erzeugen Sie Solarstrom auf dem Dach und liefern ihn direkt an Ihre Mieter — ein Vorteil für beide Seiten.</p>
            </>
          ),
          ctaLabel: "Zur Photovoltaik →",
          ctaHref: "/photovoltaik",
          image: asset_mehrfamilienhaus_mieterstrom,
          imageAlt: "Mehrfamilienhaus mit Photovoltaik-Anlage auf Flachdach in Emmerich am Rhein bei Sonnenuntergang",
        },
        {
          title: (
            <>
              <span style={{ color: "#4CAF50" }}>WERT ERHALTEN</span>, KOSTEN SENKEN
            </>
          ),
          body: "Eine moderne Energieausstattung steigert die Attraktivität und den Wert Ihrer Immobilie.",
          image: asset_mehrfamilienhaus_wert_erhalten,
          imageAlt: "Modernes Mehrfamilienhaus mit Balkonen und Photovoltaik-Anlage auf dem Dach in Emmerich am Rhein",
        },
        {
          title: "LADEN FÜR ALLE",
          body: "Wallbox-Lösungen für Stellplätze — gemeinschaftlich oder pro Einheit, sauber geplant.",
          ctaLabel: "Zur Wallbox →",
          ctaHref: "/wallbox",
          image: asset_mehrfamilienhaus_laden_fuer_alle,
          imageAlt: "Reihe von Wallboxen in Tiefgarage eines Mehrfamilienhauses mit ladendem E-Auto",
        },
        {
          title: "EIN ANSPRECHPARTNER",
          titleSize: "clamp(1.125rem, 3.2vw, 2.25rem)",
          body: "Von der Planung bis zur Betreuung — alles aus einer Hand, statt vieler einzelner Gewerke.",
        image: asset_mehrfamilienhaus_ansprechpartner,
        imageAlt: "Ansprechpartner am Schreibtisch mit Tablet vor Mehrfamilienhaus in Emmerich am Rhein",
        },
      ]}
      testimonials={allTestimonials}
      manifest={<>EIN DACH.<br />VIELE PARTEIEN.<br />EINE ENERGIELÖSUNG.</>}
      caseStudy={{
        title: "MIETERSTROM AUF MEHRFAMILIENHAUS",
        text: "PV-Anlage mit Mieterstromkonzept und Wechselrichtertechnik auf einem Mehrfamilienhaus in Emmerich am Rhein und Umgebung.",
        href: "/referenzen",
        linkLabel: "Mehr Referenzen",
        image: "https://www.zweering-elektrotechnik.de/wp-content/uploads/2026/01/OgiJ0q0ux6AqMS0SseY.jpg",
        imageAlt: "Referenz: Mieterstrom-Projekt auf Mehrfamilienhaus in Emmerich am Rhein",
      }}
      faq={[
        {
          frage: "Was ist Mieterstrom?",
          antwort:
            "Sie erzeugen Solarstrom auf dem Dach und liefern ihn direkt an Ihre Mieter — günstiger als Netzstrom, ein Vorteil für beide Seiten.",
        },
        {
          frage: "Lohnt sich das für Vermieter?",
          antwort:
            "Mieterstrom steigert die Attraktivität der Immobilie und schafft einen zusätzlichen Nutzen. Wir prüfen die Wirtschaftlichkeit für Ihr Objekt.",
        },
        {
          frage: "Übernehmen Sie die Planung komplett?",
          antwort:
            "Ja. Von Konzept über Installation bis Betreuung — aus einer Hand, ohne dass Sie viele Gewerke koordinieren müssen.",
        },
        {
          frage: "Auch für Eigentümergemeinschaften?",
          antwort:
            "Ja. Wir beraten WEGs und Hausverwaltungen zu passenden Lösungen für das gemeinsame Gebäude.",
        },
      ]}
      ctaText={{
        headline: "IHR MEHRFAMILIENHAUS ZUKUNFTSSICHER MACHEN?",
        subtext:
          "Kostenlose Beratung für Vermieter und Eigentümergemeinschaften.",
        buttonLabel: "Beratung anfragen",
        buttonHref: "/kontakt",
        variant: "green",
      }}
      crossLink={{
        title: "G2 CONTRACTING",
        text: "Energie als Geschäftsmodell — besonders für größere Objekte.",
        href: "/g2-contracting",
        image: mehrfamilienhausG2ContractingAsset,
        imageAlt: "Landwirtschaftliches Gebäude mit großer Photovoltaik-Anlage auf dem Dach",
      }}
    />
    </>
  );
}
